module.exports = __webpack_public_path__ + "img/home_popup_ios.e898832e.png";